export default __webpack_public_path__ + "static/media/facebook.9a0f14fc.svg";